'use client';

import { useEffect } from 'react';

export default function ExternalLinkHandler() {
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const href = link.getAttribute('href');
      if (href && href.startsWith('http')) {
        try {
          const url = new URL(href);
          // If the hostname is different from the current site's hostname, it's external
          if (url.hostname !== window.location.hostname) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
            // Let the browser handle the navigation naturally to the new tab
          }
        } catch (err) {
          // Ignore invalid URLs
        }
      }
    };

    // Use event delegation to catch all clicks, even on dynamically inserted elements
    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, []);

  return null;
}
